module.exports = __webpack_public_path__ + "assets/Lato-Regular.5b9025dda4d7688e3311b0c17eddc501133b807def33effaef6593843cf5416e.woff";